/* TBO CRO 2026-08-29 - PRODUCT PAGE POLISH (audit P3-14)

   Three small fixes. sections/main-product.liquid is 110KB, so these are done
   here rather than by rewriting that file.

   1. Single-option variant pickers are hidden. A "Size" control offering one
      choice is noise next to the buy button.
   2. The pickup location reads "Store Pickup", which tells a shopper nothing.
      Relabelled to the actual address. Done in the theme on purpose: the
      Shopify location name feeds ShipStation and Advatix OMS, so renaming the
      location itself risks breaking a warehouse integration.
   3. Breadcrumbs, which the product page had none of, so there was no path
      back into the category.

   ROLLBACK = delete this file and its script tag in snippets/tbo-cro-0829.liquid.
*/
(function () {
  'use strict';

  var PICKUP_FROM = /Store Pickup/g;
  var PICKUP_TO = 'Whittier - 6751 Painter Ave';

  // Verified live on the storefront before shipping.
  var TYPE_TO_COLLECTION = {
    'bourbon': ['Bourbon', '/collections/bourbon-whiskey'],
    'whiskey': ['Whiskey', '/collections/whiskey'],
    'scotch': ['Scotch', '/collections/scotch-whiskey'],
    'vodka': ['Vodka', '/collections/vodka'],
    'tequila': ['Tequila', '/collections/tequila'],
    'gin': ['Gin', '/collections/gin'],
    'rum': ['Rum', '/collections/rum'],
    'liqueur': ['Liqueur', '/collections/liqueur'],
    'cognac': ['Cognac & Brandy', '/collections/cognac-brandy'],
    'wine': ['Wine', '/collections/wine'],
    'beer': ['Beer', '/collections/beer'],
    'non-alcoholic': ['Non-Alcoholic', '/collections/non-alcoholic']
  };

  function hideSingleOptionPickers() {
    var picker = document.querySelector('variant-selects, variant-radios, .product-form__input');
    if (!picker) return;

    document.querySelectorAll('.product-form__input').forEach(function (group) {
      var radios = group.querySelectorAll('input[type="radio"]');
      var select = group.querySelector('select');
      var only = false;

      if (radios.length === 1) only = true;
      if (select && select.options.length === 1) only = true;

      if (only) group.style.display = 'none';
    });
  }

  function relabelPickup() {
    var scopes = document.querySelectorAll('pickup-availability, .product__pickup-availabilities, pickup-availability-preview');
    scopes.forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.indexOf('Store Pickup') !== -1) {
          node.nodeValue = node.nodeValue.replace(PICKUP_FROM, PICKUP_TO);
        }
      }
    });
  }

  function addBreadcrumbs(product) {
    if (document.querySelector('.tbo-crumbs')) return;

    var h1 = document.querySelector('.product__info-container h1, .product__title h1, h1');
    if (!h1) return;

    var trail = [['Home', '/']];

    // If the shopper arrived through a collection, Shopify puts it in the URL
    // and that is the truest crumb.
    var m = window.location.pathname.match(/\/collections\/([^/]+)\/products\//);
    if (m) {
      trail.push([m[1].replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }), '/collections/' + m[1]]);
    } else {
      var t = (product.type || '').toLowerCase();
      var key = Object.keys(TYPE_TO_COLLECTION).find(function (k) { return t.indexOf(k) !== -1; });
      if (key) trail.push(TYPE_TO_COLLECTION[key]);
    }

    var nav = document.createElement('nav');
    nav.className = 'tbo-crumbs';
    nav.setAttribute('aria-label', 'Breadcrumb');
    nav.innerHTML = '<ol>' + trail.map(function (c) {
      return '<li><a href="' + c[1] + '">' + c[0] + '</a></li>';
    }).join('') + '<li aria-current="page">' + (product.title || '').split(',')[0] + '</li></ol>';

    h1.parentNode.insertBefore(nav, h1);
  }

  function boot() {
    if (!/\/products\//.test(window.location.pathname)) return;

    try { hideSingleOptionPickers(); } catch (e) {}
    try { relabelPickup(); } catch (e) {}

    // Pickup availability renders asynchronously.
    var tries = 0;
    var t = setInterval(function () {
      relabelPickup();
      if (++tries > 10) clearInterval(t);
    }, 700);

    var handle = window.location.pathname.split('/products/')[1];
    if (!handle) return;
    handle = handle.split(/[?#]/)[0];

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { try { addBreadcrumbs(p); } catch (e) {} })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
